export const fileTypes = {
  'text/plain': 'txt',
  'application/pdf': 'pdf',
  'text/csv': 'csv',
  'application/json': 'json',
};
